import { FormSelect } from "@/shared/forms";
import { useMemo } from "react";
import { useSuppliersLookupQuery } from "../api/suppliers-queries";

const NONE = "__none__";

type IngredientDefaultSupplierFieldProps = {
  fallbackOption?: { id: string; label: string };
};

export function IngredientDefaultSupplierField({
  fallbackOption,
}: IngredientDefaultSupplierFieldProps) {
  const lookup = useSuppliersLookupQuery();

  const options = useMemo(() => {
    const rows = lookup.data ?? [];
    const base = [
      { value: NONE, label: "— ບໍ່ຜູກຜູ້ສະໜອງ —" },
      ...rows.map((s) => ({
        value: s.id,
        label: s.code ? `${s.name} (${s.code})` : s.name,
      })),
    ];
    if (
      fallbackOption &&
      !base.some((o) => o.value === fallbackOption.id)
    ) {
      base.push({
        value: fallbackOption.id,
        label: `${fallbackOption.label} (ປິດໃຊ້)`,
      });
    }
    return base;
  }, [lookup.data, fallbackOption]);

  return (
    <FormSelect
      name="defaultSupplierId"
      label="ຜູ້ສະໜອງຫຼັກ (PO)"
      options={options}
      placeholder={lookup.isLoading ? "ກຳລັງໂຫຼດ..." : "ເລືອກຜູ້ສະໜອງ"}
    />
  );
}

export function defaultSupplierIdFromFormValue(value: string): string | null {
  return value === NONE || !value ? null : value;
}

export function defaultSupplierIdToFormValue(
  id: string | null | undefined,
): string {
  return id ?? NONE;
}
